// @flow

import * as React from 'react'
import Helmet from 'react-helmet'
import type { ComponentType } from 'react'
import { global } from '@toggl/style'
import { Global } from '@emotion/core'

import LayoutRoot from 'components/LayoutRoot'

const IndexLayout: ComponentType<any> = ({
  title,
  description,
  keywords,
  children,
  ogImage,
  favicon,
}: {
  title?: string,
  description?: string,
  children: React.Node,
  keywords?: string,
  ogImage?: string,
  favicon?: string,
}) => (
  <LayoutRoot>
    <Global styles={global} />
    <Helmet>
      <title itemProp="name" lang="en">
        {title}
      </title>
      <meta
        name="description"
        content={description || 'Get your team on Track'}
      />
      <meta name="keywords" content={keywords || 'time,tracking'} />
      <meta
        name="og:image"
        content={ogImage || require('assets/toggl-track-main.jpg')}
      />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta name="twitter:card" content="summary_large_image" />
      <link
        rel="icon"
        type="image/png"
        href={favicon || require('assets/favicon-track.png')}
        sizes="32x32"
      />
    </Helmet>
    {children}
  </LayoutRoot>
)

export default IndexLayout
